module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbz-box"
  }, [_c('div', {
    staticClass: "zbz-box-container"
  }, [_c('div', {
    staticClass: "zbz-bg-layer",
    style: (_vm.backgroundStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-bg-overlay"
  }), _vm._v(" "), (_vm.isHost || _vm.showViewerLeft) ? _c('div', {
    staticClass: "zbz-left"
  }, [(_vm.isHost) ? _c('div', {
    staticClass: "zbz-zhiboshezhi"
  }, [_c('div', {
    staticClass: "zbz-left-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojiansetting')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-settings"
  }, [_c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleSound
    }
  }, [(_vm.soundOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kaiqishengyin_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.soundOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_guanbishengyin_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.soundOn ? _vm.$t('all.kaiqishengyin') : _vm.$t('all.guanbishengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleDanmu
    }
  }, [(_vm.danmuOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqdanmu_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.danmuOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_guanbidanmu_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.danmuOn ? _vm.$t('all.guanbidanmu') : _vm.$t('all.kaiqidanmu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleMic
    }
  }, [(_vm.micOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqmaikefeng_28@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_gbmaikefeng_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.micOn ? _vm.$t('all.guanbimaikefeng') : _vm.$t('all.kaiqimaikefeng')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleHostCamera
    }
  }, [(_vm.cameraOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_shipin_k_24@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_shipin_g_24@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.cameraOn ? _vm.$t('all.guanbishexiangtou') : _vm.$t('all.kaiqishexiangtou')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.toggleHostMirror
    }
  }, [(_vm.mirrorOn) ? _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqijingxiang_28@2x.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_guanbijingxiang_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.mirrorOn ? _vm.$t('all.guanbijingxiang') : _vm.$t('all.kaiqijingxiang')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleShowNotice
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_gonggao_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.gonggao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleShare
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_fxlj_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxianglianjie')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-setting-item",
    on: {
      "click": _vm.handleCreateHelpLive
    }
  }, [_c('img', {
    staticClass: "zbz-setting-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqxtzb_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-setting-text"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isHost) ? _c('div', {
    staticClass: "zbz-viewer-goods-title"
  }, [_c('span', {
    staticClass: "zbz-goods-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-viewer-goods-title-img",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showViewerLeft = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-zhiboshangpin"
  }, [(_vm.isHost) ? _c('div', {
    staticClass: "zbz-goods-header"
  }, [_c('span', {
    staticClass: "zbz-goods-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-setting",
    attrs: {
      "src": require("../../../assets/image/shangpinshezhi@2x.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-list"
  }, [_vm._l((_vm.goodsList), function(item, index) {
    return (_vm.isHost) ? _c('div', {
      key: 'h' + index,
      staticClass: "zbz-goods-item"
    }, [_c('img', {
      staticClass: "zbz-goods-img",
      attrs: {
        "src": item.mediasList[0].uri,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-goods-item-content"
    }, [_c('div', {
      staticClass: "zbz-goods-info"
    }, [_c('span', {
      staticClass: "zbz-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-stock"
    }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(item.totalStock))])]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-goods-price"
    }, [_c('span', {
      staticClass: "zbz-viewer-price-text"
    }, [_vm._v("USDN " + _vm._s(item.price))]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-buy-btn",
      on: {
        "click": function($event) {
          return _vm.setGoodsExplain(item)
        }
      }
    }, [_vm._v(_vm._s(item.isExplain === 1 ? _vm.$t('all.jiangjiezhong') : _vm.$t('all.jiangjie')))])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.goodsList), function(item, index) {
    return (!_vm.isHost) ? _c('div', {
      key: 'v' + index,
      staticClass: "zbz-goods-item zbz-viewer-goods-item",
      on: {
        "click": function($event) {
          return _vm.handleViewGoodsDetail(item)
        }
      }
    }, [_c('img', {
      staticClass: "zbz-goods-img",
      attrs: {
        "src": item.mediasList[0].uri,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-goods-item-content"
    }, [_c('div', {
      staticClass: "zbz-goods-info"
    }, [_c('span', {
      staticClass: "zbz-goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-stock"
    }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(item.totalStock))])]), _vm._v(" "), _c('div', {
      staticClass: "zbz-viewer-goods-price"
    }, [_c('span', {
      staticClass: "zbz-viewer-price-text"
    }, [_vm._v("USDN " + _vm._s(item.price))]), _vm._v(" "), (item.totalStock > 0) ? _c('div', {
      staticClass: "zbz-viewer-buy-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBuyGoods(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.qianggou')))]) : _c('div', {
      staticClass: "zbz-viewer-buy-btn1"
    }, [_vm._v(_vm._s(_vm.$t('all.yishouqing')))])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.goodsList && _vm.goodsList.length == 0) ? _c('kong', {
    staticClass: "kong"
  }) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-center"
  }, [_c('div', {
    staticClass: "zbz-video-area"
  }, [_c('div', {
    staticClass: "zbz-video-wrap"
  }, [(_vm.isHost && _vm.data && _vm.data.mainScreenHelpId == 0) ? _c('tengxunyunzb', {
    ref: "txyzb",
    attrs: {
      "room-data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHost && _vm.data && _vm.data.mainScreenHelpId == 0) ? _c('tengxunyun', {
    ref: "txy"
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.mainScreenHelpId > 0) ? _c('mainscreenplayer', {
    attrs: {
      "main-screen-data": _vm.mainScreenUser,
      "is-self": _vm.isSelfMainScreen,
      "self-user-id": _vm.currentUserId
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data) ? _c('xietongzhibo', {
    ref: "xietongzhibo",
    attrs: {
      "is-host": _vm.isHost,
      "room-data": _vm.data
    },
    on: {
      "select": _vm.handleColiveSelect,
      "joinsuccess": _vm.handleJoinSuccess
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-popup",
    class: {
      'zbz-video-product-popup-show': _vm.showProductPopup && _vm.productPopupData && !_vm.isHost
    }
  }, [_c('div', {
    staticClass: "zbz-video-product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.productPopupData && _vm.productPopupData.mediasList && _vm.productPopupData.mediasList[0] ? _vm.productPopupData.mediasList[0].uri : '',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-info"
  }, [_c('span', {
    staticClass: "zbz-video-product-name"
  }, [_vm._v(_vm._s(_vm.productPopupData && _vm.productPopupData.goodsName ? _vm.productPopupData.goodsName : ''))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-video-product-price"
  }, [_vm._v(_vm._s(_vm.productPopupData ? _vm.productPopupData.price : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-video-product-btn",
    on: {
      "click": _vm.handleProductClick
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-video-product-gb",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showProductPopup = false
      }
    }
  })])], 1), _vm._v(" "), (_vm.isHost) ? _c('div', {
    staticClass: "zbz-video-bottom"
  }, [_c('div', {
    staticClass: "zbz-volume"
  }, [(_vm.volume > 0) ? _c('img', {
    staticClass: "zbz-volume-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqmaikefeng_28@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.setVolume(0)
      }
    }
  }) : _c('img', {
    staticClass: "zbz-volume-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_gbmaikefeng_28@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.setVolume(100)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.volume),
      expression: "volume"
    }],
    staticClass: "zbz-volume-slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "input": _vm.handleVolumeChange,
      "__r": function($event) {
        _vm.volume = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-volume-text"
  }, [_vm._v(_vm._s(_vm.volume) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-end-btn",
    on: {
      "click": _vm.handleEndLive
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jieshizhibo')))])]) : _vm._e(), _vm._v(" "), (!_vm.isHost) ? _c('div', {
    staticClass: "zbz-viewer-bottom"
  }, [(_vm.isJoinedHelpLive) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleViewerMic
    }
  }, [(_vm.viewerMicOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqmaikefeng_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewerMicOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_gbmaikefeng_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.maikefeng')))])]) : _vm._e(), _vm._v(" "), (_vm.isJoinedHelpLive) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleViewerCamera
    }
  }, [(_vm.viewerCameraOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_shipin_k_24@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.viewerCameraOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_shipin_g_24@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.shipin')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleViewerSound
    }
  }, [(_vm.soundOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kaiqishengyin_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.soundOn) ? _c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_guanbishengyin_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.soundOn ? _vm.$t('all.guanbishengyin') : _vm.$t('all.kaiqishengyin')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.toggleDanmu
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqdanmu_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.danmuOn ? _vm.$t('all.guanbidanmu') : _vm.$t('all.kaiqidanmu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShare
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_fxlj_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.fenxianglianjie')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShowNotice
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_gonggao_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.chakangg')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleShowGoods
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/shangpin_24@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')))])]), _vm._v(" "), (_vm.data && _vm.data.isOpenHelp == 1) ? _c('div', {
    staticClass: "zbz-viewer-bottom-item",
    on: {
      "click": _vm.handleHelpLiveToggle
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kqxtzb_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isJoinedHelpLive ? _vm.$t('all.tuichuxietongzhibo') : _vm.$t('all.jiaruxietongzhibo')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-viewer-reward-btn",
    on: {
      "click": _vm.handleReward
    }
  }, [_c('img', {
    staticClass: "zbz-viewer-bottom-icon",
    attrs: {
      "src": require("../../../assets/image/dashang_26@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.dashang')))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-right"
  }, [_c('div', {
    staticClass: "zbz-online"
  }, [_c('div', {
    staticClass: "zbz-online-title"
  }, [_c('img', {
    staticClass: "zbz-online-icon",
    attrs: {
      "src": require("../../../assets/image/zhibojian_zaixianguanzhong@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-online-text"
  }, [_vm._v(_vm._s(_vm.$t('all.zaixianguanzhong')) + "：" + _vm._s(_vm.onlineCount))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-online-list"
  }, [_vm._l((_vm.onlineUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-online-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowOnlineFj(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "zbz-online-item-sort"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-online-item-img",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-online-item-name"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), (_vm.isHost && _vm.showOnlineFj && _vm.onlineIndex == index) ? _c('div', {
      staticClass: "zbz-chat-item-fj"
    }, [_c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBannedUserById()
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.onlineUserInfo.isBannedToPost === 0 ? _vm.$t('all.yongjiujinyan') : _vm.$t('all.jiechuejinyan')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": require("../../../assets/image/xiayibu_10@2x.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleKickUserById(item.userId)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.tichubenchang')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": require("../../../assets/image/xiayibu_10@2x.png"),
        "alt": ""
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.onlineUserList.length === 0) ? _c('div', {
    staticClass: "zbz-online-empty"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.zanwuzaixianguanzhong')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "zbz-dashang"
  }, [_c('div', {
    ref: "rewardContainer",
    staticClass: "zbz-dashang-box"
  }, _vm._l((_vm.rewardList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-reward-item"
    }, [_c('img', {
      staticClass: "zbz-reward-avatar",
      attrs: {
        "src": item.sendUserInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-name"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-text"
    }, [_vm._v(_vm._s(_vm.$t('all.dashang')))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-amount"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-unit"
    }, [_vm._v(_vm._s(item.unitText))])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "chatContainer",
    staticClass: "zbz-chat-list"
  }, _vm._l((_vm.msgList), function(msg, index) {
    return (_vm.danmuOn) ? _c('div', {
      key: index,
      staticClass: "zbz-chat-item"
    }, [_c('div', {
      staticClass: "zbz-chat-item-box"
    }, [_c('div', {
      staticClass: "zbz-chat-content-wrapper",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShowModelFj(msg, index)
        }
      }
    }, [(msg.sendUserInfo) ? _c('span', {
      staticClass: "zbz-chat-nickname"
    }, [_vm._v(_vm._s(msg.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text"
    }, [(msg.type == -1) ? [_c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": require("../../../assets/image/xlp.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (!msg.sendUserInfo && !msg.type) ? [_c('span', {
      staticClass: "zbz-chat-text-system"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 3) ? [_c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 1) ? [_c('span', {
      staticClass: "zbz-chat-text-join"
    }, [_vm._v(_vm._s(msg.title))])] : _vm._e(), _vm._v(" "), (msg.type == 12) ? [_c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v(_vm._s(_vm.$t('all.songgei')) + _vm._s(msg.toUserInfo.nickName) + _vm._s(msg.giftInfo.content))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-gift-img",
      attrs: {
        "src": msg.giftInfo.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "zbz-chat-text-msg"
    }, [_vm._v("×" + _vm._s(msg.num))])] : _vm._e()], 2)])]), _vm._v(" "), (_vm.isHost && _vm.showModelFj && _vm.msgIndex == index) ? _c('div', {
      staticClass: "zbz-chat-item-fj"
    }, [_c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleBannedUser(msg)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.sendUserInfo.isBannedToPost === 0 ? _vm.$t('all.yongjiujinyan') : _vm.$t('all.jiechuejinyan')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": require("../../../assets/image/xiayibu_10@2x.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "zbz-chat-item-fj-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleKickUser(msg)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.tichubenchang')))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-chat-xiaolapa",
      attrs: {
        "src": require("../../../assets/image/xiayibu_10@2x.png"),
        "alt": ""
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-quick-bar"
  }, [(_vm.kjdyList.length > 0) ? _c('div', {
    ref: "quickTags",
    staticClass: "zbz-quick-tags",
    on: {
      "mousedown": _vm.startDragScroll,
      "mousemove": _vm.doDragScroll,
      "mouseup": _vm.stopDragScroll,
      "mouseleave": _vm.stopDragScroll
    }
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-quick-item",
      on: {
        "click": function($event) {
          return _vm.handleSendKjdy(item.content)
        }
      }
    }, [_vm._v(_vm._s(item.content))])
  }), _vm._v(" "), (_vm.showKjdyTags) ? _c('img', {
    staticClass: "zbz-quick-close",
    attrs: {
      "src": require("../../../assets/image/x_22_1@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyTags = false
      }
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isHost) ? _c('img', {
    staticClass: "zbz-quick-manage-icon",
    attrs: {
      "src": require("../../../assets/image/zbsz_kuaijiefayan_28@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyModal = true
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-send"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatContent),
      expression: "chatContent"
    }],
    ref: "chatInput",
    staticClass: "zbz-send-input",
    attrs: {
      "placeholder": _vm.$t('all.shuodianshenmene'),
      "rows": "1"
    },
    domProps: {
      "value": (_vm.chatContent)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.handleSend.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.chatContent = $event.target.value
      }, _vm.autoResize]
    }
  })]), _vm._v(" "), (_vm.showKjdyModal) ? _c('div', {
    staticClass: "zbz-kjdy-modal"
  }, [_c('div', {
    staticClass: "zbz-kjdy-header"
  }, [_c('img', {
    staticClass: "zbz-kjdy-add",
    attrs: {
      "src": require("../../../assets/image/tianjia_20@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyAdd = true
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-kjdy-title"
  }, [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-kjdy-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showKjdyModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-list"
  }, [_vm._l((_vm.kjdyList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-kjdy-item"
    }, [_c('span', {
      staticClass: "zbz-kjdy-item-text"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('img', {
      staticClass: "zbz-kjdy-item-del",
      attrs: {
        "src": require("../../../assets/image/x_22_1@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleDelKjdy(item.id)
        }
      }
    })])
  }), _vm._v(" "), (_vm.kjdyList.length === 0) ? _c('div', {
    staticClass: "zbz-kjdy-empty"
  }, [_vm._v(_vm._s(_vm.$t('all.zanwushuju')))]) : _vm._e()], 2), _vm._v(" "), (_vm.showKjdyAdd) ? _c('div', {
    staticClass: "zbz-kjdy-add-modal"
  }, [_c('div', {
    staticClass: "zbz-kjdy-add-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xinzengkuaijieduanyu')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newKjdyContent),
      expression: "newKjdyContent"
    }],
    staticClass: "zbz-kjdy-add-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.newKjdyContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newKjdyContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-add-btns"
  }, [_c('div', {
    staticClass: "zbz-kjdy-add-cancel",
    on: {
      "click": function($event) {
        _vm.showKjdyAdd = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-kjdy-add-confirm",
    on: {
      "click": _vm.handleAddKjdy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showNotice) ? _c('div', {
    staticClass: "zbz-notice-modal"
  }, [_c('div', {
    staticClass: "zbz-notice-mask",
    on: {
      "click": _vm.handleCloseNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-notice-content"
  }, [_c('div', {
    staticClass: "zbz-notice-header"
  }, [_c('span', {
    staticClass: "zbz-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('all.gonggao')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-notice-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleCloseNotice
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-notice-body"
  }, [(_vm.isHost || _vm.noticeText) ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeText),
      expression: "noticeText"
    }],
    class: {
      'zbz-notice-textarea-disabled': !_vm.isHost
    },
    attrs: {
      "placeholder": _vm.$t('all.qingshuru'),
      "disabled": !_vm.isHost
    },
    domProps: {
      "value": (_vm.noticeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noticeText = $event.target.value
      }
    }
  })] : _c('div', {
    staticClass: "zbz-notice-empty"
  }, [_vm._v(_vm._s(_vm.$t('all.zanwugonggao')))])], 2), _vm._v(" "), (_vm.isHost) ? _c('div', {
    staticClass: "zbz-notice-footer"
  }, [_c('div', {
    staticClass: "zbz-notice-btn",
    on: {
      "click": _vm.handleUpdateNotice
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.showRewardModal) ? _c('div', {
    staticClass: "zbz-reward-overlay",
    on: {
      "click": function($event) {
        _vm.showRewardModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRewardModal) ? _c('div', {
    staticClass: "zbz-reward-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-reward-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzedashangbizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-coins"
  }, _vm._l((_vm.walletList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.rewardCoinIndex === index ? 'zbz-reward-coin-active' : 'zbz-reward-coin',
      on: {
        "click": function($event) {
          _vm.rewardCoinIndex = index
        }
      }
    }, [_c('img', {
      staticClass: "zbz-reward-coin-icon",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-reward-coin-content"
    }, [_c('span', {
      staticClass: "zbz-reward-coin-name"
    }, [_vm._v(_vm._s(item.unitText))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-reward-coin-balance"
    }, [_vm._v(_vm._s(_vm.$t('all.yue')) + " " + _vm._s(item.sumAvailableAmount))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-section"
  }, [_vm._v(_vm._s(_vm.$t('all.dashangjine')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-amounts"
  }, [_vm._l((_vm.giveAmountConfig.amountList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.rewardAmountIndex === index ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a',
      on: {
        "click": function($event) {
          _vm.rewardAmountIndex = index;
          _vm.customAmount = ''
        }
      }
    }, [_vm._v(_vm._s(item) + " " + _vm._s(_vm.walletList[_vm.rewardCoinIndex].unitText))])
  }), _vm._v(" "), _c('div', {
    class: _vm.customAmount ? 'zbz-reward-amount-active' : 'zbz-reward-amount-a',
    on: {
      "click": function($event) {
        _vm.rewardAmountIndex = -1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zidingyi')))])], 2), _vm._v(" "), (_vm.rewardAmountIndex === -1) ? _c('div', {
    staticClass: "zbz-reward-custom-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customAmount),
      expression: "customAmount"
    }],
    staticClass: "zbz-reward-input",
    attrs: {
      "type": "number",
      "step": "0.01",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = $event.target.value
      }, _vm.handleCustomAmountInput]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-reward-input-unit"
  }, [_vm._v(_vm._s(_vm.walletList[_vm.rewardCoinIndex].unitText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-total"
  }, [_c('span', {
    staticClass: "zbz-reward-total-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dashangjine')))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-reward-total-value"
  }, [_vm._v(_vm._s(_vm.rewardAmountIndex >= 0 ? _vm.rewardAmounts[_vm.rewardAmountIndex] : _vm.customAmount) + " " + _vm._s(_vm.walletList[_vm.rewardCoinIndex].unitText))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-reward-btn",
    on: {
      "click": _vm.handleConfirmReward
    }
  }, [_vm._v(_vm._s(_vm.$t('all.querendashang')))])]) : _vm._e(), _vm._v(" "), (_vm.showGoodsDetail) ? _c('div', {
    staticClass: "zbz-goods-detail-overlay",
    on: {
      "click": function($event) {
        _vm.showGoodsDetail = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGoodsDetail && _vm.selectedGoods) ? _c('div', {
    staticClass: "zbz-goods-detail-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-goods-detail-header"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-header-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-detail-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showGoodsDetail = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-body"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-carousel"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-carousel-inner",
    style: ({
      transform: 'translateX(-' + _vm.detailCarouselIndex * 100 + '%)'
    })
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('img', {
      key: index,
      staticClass: "zbz-goods-detail-carousel-img",
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  }), 0), _vm._v(" "), (_vm.selectedGoodsImages.length > 1) ? _c('div', {
    staticClass: "zbz-goods-detail-carousel-dots"
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('span', {
      key: index,
      class: _vm.detailCarouselIndex === index ? 'zbz-goods-detail-dot-active' : 'zbz-goods-detail-dot',
      on: {
        "click": function($event) {
          _vm.detailCarouselIndex = index
        }
      }
    })
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-price-row"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-price-left"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-price-label"
  }, [_vm._v("USDN")]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-price-value"
  }, [_vm._v(_vm._s(_vm.selectedGoods.price))])]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-stock"
  }, [_vm._v(_vm._s(_vm.$t('all.shangchengkucun')) + "：" + _vm._s(_vm.selectedGoods.totalStock))])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-name"
  }, [_vm._v(_vm._s(_vm.selectedGoods.goodsName))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-divider"
  }, [_c('span', {
    staticClass: "zbz-goods-detail-divider-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-divider-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shangpinxiangqing')))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-detail-divider-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-images"
  }, _vm._l((_vm.selectedGoodsImages), function(img, index) {
    return _c('img', {
      key: index,
      staticClass: "zbz-goods-detail-desc-img",
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-detail-footer"
  }, [_c('div', {
    staticClass: "zbz-goods-detail-buy-btn",
    on: {
      "click": _vm.handleDetailBuy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])]) : _vm._e(), _vm._v(" "), (_vm.showGoodsModal) ? _c('div', {
    staticClass: "zbz-goods-overlay",
    on: {
      "click": function($event) {
        _vm.showGoodsModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGoodsModal) ? _c('div', {
    staticClass: "zbz-goods-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-goods-modal-header"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-header-span"
  }, [_vm._v(_vm._s(_vm.$t('all.goumaishangpin')))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-modal-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showGoodsModal = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-body"
  }, [_c('div', {
    staticClass: "zbz-goods-modal-info"
  }, [_c('img', {
    staticClass: "zbz-goods-modal-img",
    attrs: {
      "src": _vm.selectedGoods.mediasList[0].uri,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-detail"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-name"
  }, [_vm._v(_vm._s(_vm.selectedGoods.goodsName))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-selected"
  }, [_vm._v(_vm._s(_vm.$t('all.yixuan')) + "：" + _vm._s(_vm.selectedSpec.name))]), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-price"
  }, [_vm._v("USDN " + _vm._s(_vm.selectedSpec.price))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-info-kucun"
  }, [_c('span', {
    staticClass: "zbz-goods-modal-info-kucun-span"
  }, [_vm._v(_vm._s(_vm.$t('all.kucun')) + "：" + _vm._s(_vm.selectedSpec.inventory))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-count"
  }, [_c('img', {
    staticClass: "zbz-goods-modal-count-btn",
    attrs: {
      "src": require("../../../assets/image/shuliang_jian@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.decreaseBuyCount
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zbz-goods-modal-count-num"
  }, [_vm._v(_vm._s(_vm.buyCount))]), _vm._v(" "), _c('img', {
    staticClass: "zbz-goods-modal-count-btn",
    attrs: {
      "src": require("../../../assets/image/shuliang_jia@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.increaseBuyCount
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-section"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeguiige')))]), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-specs"
  }, _vm._l((_vm.selectedGoods.specificationList), function(item) {
    return _c('div', {
      key: item.dbSpecificationId,
      class: _vm.selectedSpec.dbSpecificationId === item.dbSpecificationId ? 'zbz-goods-modal-spec-active' : 'zbz-goods-modal-spec',
      on: {
        "click": function($event) {
          return _vm.selectSpec(item)
        }
      }
    }, [_c('span', {
      staticClass: "zbz-goods-modal-spec-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "zbz-goods-modal-spec-price"
    }, [_vm._v("USDN " + _vm._s(item.price))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zbz-goods-modal-footer"
  }, [_c('div', {
    staticClass: "zbz-goods-modal-add-btn",
    on: {
      "click": _vm.handleAddToCart
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijijiagou')))])])])]) : _vm._e(), _vm._v(" "), (_vm.showShareLink) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showShareLink = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareLink) ? _c('div', {
    staticClass: "xtzb-share-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-share-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangyaoqing')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-qrcode"
  }, [_c('canvas', {
    ref: "qrcodeCanvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqinglianjie')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.data.shareUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangfangshi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-actions"
  }, [_c('div', {
    staticClass: "xtzb-share-action-btn xtzb-share-action-gradient",
    on: {
      "click": _vm.handleCopyLink
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhilianjie')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-action-btn",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))])])]) : _vm._e(), _vm._v(" "), (_vm.showLiveRecord) ? _c('div', {
    staticClass: "zbz-record-overlay",
    on: {
      "click": function($event) {
        _vm.showLiveRecord = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLiveRecord) ? _c('div', {
    staticClass: "zbz-record-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "zbz-record-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('div', {
    ref: "recordList",
    staticClass: "zbz-record-list",
    on: {
      "scroll": _vm.handleRecordScroll
    }
  }, [_vm._l((_vm.liveRecordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zbz-record-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayRecord(item)
        }
      }
    }, [_c('div', {
      staticClass: "zbz-record-item-cover",
      style: ({
        backgroundImage: 'url(' + item.backgroundUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "zbz-record-item-info"
    }, [_c('span', {
      staticClass: "zbz-record-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "zbz-record-item-info-div"
    }, [_c('span', {
      staticClass: "zbz-record-item-tag"
    }, [_vm._v(_vm._s(item.categoryName))]), _vm._v(" "), (item.isOpenReplay == 1 && item.replayUrl) ? _c('div', {
      staticClass: "zbz-record-item-info-div-bf",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/image/huifang@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "zbz-record-item-time"
    }, [_vm._v(_vm._s(item.liveStartTime) + " - " + _vm._s(item.liveEndTime))])])])
  }), _vm._v(" "), (!_vm.recordLoading && _vm.liveRecordList.length === 0) ? _c('kong') : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a9c2088"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhibozhong/zhibozhong.vue
// module id = 973
// module chunks = 1